module.exports = __webpack_public_path__ + "img/addon-drive.291bfb50.png";